module.exports = __webpack_public_path__ + "img/InicioHion-hd.5c7b8c03.jpg";